import type { ProfileRow } from '@/types/supabase';

export function isProfileComplete(profile: ProfileRow | null | undefined): boolean {
  if (!profile) return false;
  return !!profile.full_name?.trim() && !!profile.terms_accepted_at;
}
